import type { ReactNode } from 'react';

/**
 * Tooltip-content der vises absolut over en row-button.
 * Buttonen skal have `relative group/row` klasser for at trigger virker.
 *
 * Eksempel:
 *   <button className="... relative group/row">
 *     ...content...
 *     <RowTooltip>
 *       <strong>Sebastian Olesen</strong>
 *       <div>EN70453</div>
 *       <div>Aflevering: 4. maj 16:00</div>
 *     </RowTooltip>
 *   </button>
 */
export default function RowTooltip({ children }: { children: ReactNode }) {
  return (
    <span
      className="
        absolute z-30 left-1/2 -translate-x-1/2 bottom-full mb-2
        opacity-0 group-hover/row:opacity-100
        transition-opacity duration-150 pointer-events-none
      "
    >
      <span className="
        block min-w-[180px] max-w-[280px]
        bg-cream-50 border border-ink-200 text-ink-900
        rounded-lg px-3 py-2 text-xs shadow-card-md
        text-left whitespace-normal
      ">
        {children}
      </span>
    </span>
  );
}
